'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProviderButton = require('./ProviderButton.scss');

var _ProviderButton2 = _interopRequireDefault(_ProviderButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProviderButton, _Component);

  function ProviderButton() {
    (0, _classCallCheck3.default)(this, ProviderButton);
    return (0, _possibleConstructorReturn3.default)(this, (ProviderButton.__proto__ || (0, _getPrototypeOf2.default)(ProviderButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProviderButton, [{
    key: 'render',
    value: function render() {
      var icon = this.props.icon;
      var className = this.props.className;

      var buttonClassName = _ProviderButton2.default.providerButtonContent + (className ? ' ' + className : '');
      return _react2.default.createElement(
        'div',
        { className: buttonClassName },
        _react2.default.createElement(
          'div',
          { className: _ProviderButton2.default.providerButton, onClick: this.props.onClick },
          icon ? _react2.default.createElement('img', { src: icon }) : this.props.buttonString
        )
      );
    }
  }]);
  return ProviderButton;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  buttonString: _react.PropTypes.string,
  icon: _react.PropTypes.string,
  onClick: _react.PropTypes.func.isRequired
}, _temp);
exports.default = ProviderButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProviderButton/ProviderButton.js
// module id = 1981
// module chunks = 0